<template>
    <div id="wrap" class="full_wrap"><!-- GNB/Footer 없을때 -->
        <!-- contents -->
        <div id="container">
            <div class="container_wrap">
                <div class="msg_item">
                    <p>
                        <em>
                            <i>Test for your network access</i><br>
                            [Global SKP Renewal Project Team]
                        </em>
                        <!-- <a href="#none" class="btn_blue" title="">Click</a> -->
                    </p>
                </div>
            </div>
        </div> <!-- //container -->
    </div>
</template>

<script>
import Vue              from 'vue';
import MenuUtil         from '@/utils/MenuUtil';
import SDLUtil          from '@/utils/SDLUtil';

const command = MenuUtil.getMoveKeyDownCode;

export default {
    methods: {
        goMain() {
            // this.$router.push({ name : 'Login' });
            document.location = `${SDLUtil.WEB_CONTEXT_PATH}/directLogin`;
        }
    },
    created() {
        const that = this;
        let kkeys = [];
        $(document).keydown(function(e) {
            kkeys.push( e.keyCode );
            if ( kkeys.toString().indexOf( command ) >= 0 ) {
                kkeys = [];
                that.goMain();
            }
        });
    },
};
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/gspnCon/PageAccess.vue